import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UsuarioEsquema } from 'src/app/usuarioEsquema';
import { Usuario } from 'src/app/usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { Venimpcli } from '../veninterfaces/Venimpcli'
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class VenimpclientesService {

  private way: string;
  regtotal: string;
  public impclientes: Venimpcli[] = [];

  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');

  }
  /*envia un lciente del excel al backend  */
  procesarclientes(cliente: Venimpcli): Promise<any> {
    return this.http.post<any>(

      this.way + '/seg/getclientes/fbaf2b32b2', {
      elementos: cliente
    },
      this.confIniciales.httpOptions()
    ).toPromise();

  }

  insertarRegistroDet(arregloClientes: any[]): Promise<any> {
    const url = this.way + '/seg/impcli/fbaf2b32b2';
    console.log('this.way', this.way);
    console.log('url final', url);
    console.log('clientes enviados ', arregloClientes);
    return this.http.post<any>(

      url, {
      elementos: arregloClientes
    },
      this.confIniciales.httpOptions()
    ).toPromise();
  }

  descargarPlantilla(): Observable<HttpResponse<Blob>> {
    return this.http.get(
      this.way + '/venimpclientes/descargarPlantilla',
      {
        responseType: 'blob',
        observe: 'response'
      }
    );

  };
  limpiar(): void {
    this.impclientes = [];
  }
  getclivalidacion():Promise<any> {
    return this.http.post<any[]>(this.way + '/seg/impcli/10777eaac9aa6500000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getvenvalidacion() {

    return this.http.post<any[]>(this.way + '/seg/impcli/3eaac9aafbaed80000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getconcod1validacion() {

    return this.http.post<any[]>(this.way + '/seg/impcli/83bacc5d98688000000000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getconcod2validacion() {

    return this.http.post<any[]>(this.way + '/seg/impcli/83bacc5d9868c000000000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  
  getclicodvalidacion(arreglo) {

    return this.http.post<any[]>(this.way + '/seg/impcli/41dd6564cc37ec0000000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarclitmp(arreglo) {

    return this.http.post<any[]>(this.way + '/seg/impcli/257e3b7dedb3f8000000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarclitmp() {

    return this.http.post<any[]>(this.way + '/seg/impcli/7565695d52b67c000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getclirucvalidacion(){

    return this.http.post<any[]>(this.way + '/seg/impcli/20eeb2b2faabc0000000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getgrupcodvalidacion(){

    return this.http.post<any[]>(this.way + '/seg/impcli/83bb0dfb2cc38000000000000', {
      elementos: {
        p_USUIDENTIFICACION:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}